import React from 'react';
import './NewPatient.scss';

const NewPatient: React.FC = () => {
  return (
    <div className="new-patient-container">
      <div className="new-patient-header">
        <h1>Florida First Psychiatry Offers Neuropsychological Testing</h1>
        <p className="security-notice">Please do not send completed forms or any other type of protected health information through the website. This website is not yet set up with a secure patient portal. Please mail or hand deliver all documents to the office.</p>
      </div>

      <div className="new-patient-content">
        <section className="forms-section">
          <h2>Required Forms</h2>
          <div className="forms-grid">
            <a href="/assets/forms/Notice-of-Privacy-Practices.pdf" target="_blank" rel="noopener" className="form-card">
              <h3>Notice of Privacy Policies</h3>
            </a>
            <a href="/assets/forms/NP-Intake-Form.pdf" target="_blank" rel="noopener" className="form-card">
              <h3>Initial Intake Form</h3>
            </a>
            <a href="/assets/forms/Florida-First-Psychiatry-New-Patient-Packet.pdf" target="_blank" rel="noopener" className="form-card">
              <h3>New Patient Paperwork</h3>
            </a>
          </div>
        </section>

        <section className="info-sections">
          <div className="info-card">
            <div className="info-image">
              <img src="/assets/images/about1.jpg" alt="about-1" className="about-image" />
            </div>
            <div className="info-content">
              <h3>Providing a Range of Psychiatry Solutions</h3>
              <p>We are devoted to nurturing the whole child – Here at Florida First Psychiatry Specialist, we have a treatment team that covers life issues, personal stressors, and psychological conditions including depression, anxiety, attentional issues, and stress management. We offer practical and compassionate adult psychiatry services so you can have easy access to suitable medical care.</p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-image">
              <img src="/assets/images/about2.jpg" alt="about-2" className="about-image" />
            </div>
            <div className="info-content">
              <h3>Get in Touch With Our Psychiatry Practice</h3>
              <p>For adult and geriatric psychiatry services, turn to Florida First Psychiatry Specialist. We help individuals with a variety of psychological conditions and other life issues. If you wish to learn more about Dr. Prasanti Tatini's psychiatry practice, don't hesitate to get in touch with us.</p>
            </div>
          </div>
        </section>

        <section className="insurance-logos-section">
          <div className="insurance-logos-grid">
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-1.jpg" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-10.png" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-9.jpg" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-8.jpg" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-5.png" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-7.png" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
          </div>
        </section>

        <section className="requirements-section">
          <div className="requirements-box">
            <h3>New Patient Requirements</h3>
            <p>If you are interested in becoming a new patients here are all the requirements per FFPS policy: All New Patient Forms must be completed by the day before the appointment, must be seen in office for this appointment, as well as arrive 30 minutes before appointment time. If for any reason you need to reschedule or cancel this must be done 48 hours before the appointment time and date or you will be charge $45 dollars for the late cancel/rescheduling. For any further questions please call our office.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NewPatient;

